export const reportsKeys = {
  all: ['reports'] as const,
  metadataList: () => [...reportsKeys.all, 'metadataList'] as const,
  thoughtSpotToken: (userId: string) =>
    [...reportsKeys.all, 'thoughtSpotToken', userId] as const,
}
